import { SystemGroupSelectType1, SystemGroupSelectType2 } from '@/api'

export interface RegisterSystemGroupRequest {
  name: string
  lending: SystemGroupSelectType1
  return: SystemGroupSelectType1
  bibliography: SystemGroupSelectType2
  user: SystemGroupSelectType2
  reference: SystemGroupSelectType1
  operationMenuId: number
  topMenuId: number
  batchMenuId: number
  sessionTimeoutMinutes: number
}

export function RegisterSystemGroupRequestToJSON(
  value: RegisterSystemGroupRequest
): any {
  return {
    name: value.name !== '' ? value.name : undefined,
    lending: value.lending ?? undefined,
    return: value.return ?? undefined,
    bibliography: value.bibliography ?? undefined,
    user: value.user ?? undefined,
    reference: value.reference ?? undefined,
    operation_menu_id:
      value.operationMenuId !== 0 ? value.operationMenuId : undefined,
    top_menu_id: value.topMenuId !== 0 ? value.topMenuId : undefined,
    batch_menu_id: value.batchMenuId !== 0 ? value.batchMenuId : undefined,
    session_timeout_minutes:
      value.sessionTimeoutMinutes !== 0
        ? value.sessionTimeoutMinutes
        : undefined
  }
}
